import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';

import ViewContent
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContent';
import { useOnboardingPlannerViewContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContext';

const styles = () => ({
  root: {},
});

const ViewContainer = ({
  className,
  classes,
}) => {
  const {
    loading,
    loadingError,
  } = useOnboardingPlannerViewContext();

  return (
    <DataContainer
      className={classes.container}
      component={ViewContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while initializing the survey.',
      }}
    />
  );
};

ViewContainer.defaultProps = {
  className: '',
};

ViewContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ViewContainer);
